module.exports = __webpack_public_path__ + "static/media/Neon_Logo_Dark.ea1e5011.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neon_Logo_Dark.svg
// module id = 399
// module chunks = 0